import * as yup from 'yup'

export const schema = yup.object().shape({
    answer: yup.string()
        .required('La consulta es requerida'),
    file: yup.mixed()
})